<template style="background-color:black;">
  <b-container>
    <b-card
      no-body
      border-variant="msstream"
      bg-variant="msstream"
      text-variant="light"
    >
      <!--<b-card-header header-bg-variant="msstream" header-text-variant="light" class="text-center">Log In</b-card-header>-->
      <b-card-body>
        <b-row
          style="margin-bottom: 30px"
          class="justify-content-center text-center"
        >
          {{ message }}
        </b-row>
      </b-card-body>
    </b-card>
  </b-container>
</template>

<script>
import { EventBus } from '@/event-bus.js';
import UserService from "@/services/user.service.js";

var userService = new UserService();

export default {
  name: "ProfilPage",
  data: function () {
    return {
      mailToValidate: undefined,
      validationKey: undefined,
      message: "",
    };
  },
  mounted() {
    this.mailToValidate = this.$route.query.mail;
    this.validationKey = this.$route.query.key;

    if (!this.mailToValidate || !this.validationKey)
      this.message = "The verification link is incorrect";
    
    if (this.mailToValidate && this.validationKey) { 
      userService
        .verifyUserMail(this.mailToValidate, this.validationKey)
        .then(() => {
          this.message = `Your email address have been verified. The email attache to your account is now ${this.mailToValidate}`;
          EventBus.$emit('AuthChanged');
        })
        .catch((err) => {
          if (err.response.status === 404 || err.response.status === 401) {
            this.message = "The verification link is incorrect";
          } else if (err.response.status === 409) {
            this.message =
              "This mail has alredy been verified by another user, please change your email for another one";
          }
        });
    }
  },
};
</script>